module.exports = __webpack_public_path__ + "static/media/2Partner.009ff7c0.svg";